import { Box } from "@mui/material";

export default function GhostMosaicOverlay({
  ghostEnabled,
  capturedCount,
  ghostOpacity,
  capturedTiles,
  gridCols,
  gridRows,
  totalTiles,
}) {
  if (!ghostEnabled || capturedCount <= 0) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "grid",
        gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
        gridTemplateRows: `repeat(${gridRows}, 1fr)`,
        opacity: Math.max(0, Math.min(1, ghostOpacity / 100)),
        pointerEvents: "none",
        mixBlendMode: "screen",
      }}
      aria-hidden
    >
      {Array.from({ length: totalTiles }).map((_, idx) => {
        const r = Math.floor(idx / gridCols);
        const c = idx % gridCols;
        const key = `${r}-${c}`;
        const url = capturedTiles[key]?.url;

        return (
          <Box
            key={`ghost-mosaic-${key}`}
            sx={{
              overflow: "hidden",
              outline: "1px solid rgba(255,255,255,0.06)",
            }}
          >
            {url ? (
              <img
                src={url}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}

